import { Menu, MenuItem } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
  Message as CannedMessageButton,
  MultipleChoice as ShowChoiceButton,
  MsgHistory
} from '.././common/Buttons';
import Tooltip from '../../../../common/StyledToolTip';

const styles = (theme) => ({
  menu: {
    background: theme.ModalBGColor,
    borderRadius: '0px 0px 4px 4px'
  },
  menuItem: {
    fontSize: theme.headerTextFontSize,
    lineHeight: '14px',
    color: theme.TextColor,
    "&:hover": {
      background: theme.customMultiSelectColor,
    },
  }
});

const MessageActionMenu = ({
  anchorEl,
  handleMenuClose,
  classes,
  isChoiceMessageDisabled,
  handleMenuOptionClick,
  disableMessageHistory
}) => {
  return (
    <Menu
      classes={{
        paper: classes.menu
      }}
      id="message-menu"
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={handleMenuClose}
      MenuListProps={{
        'aria-labelledby': 'edit',
        disablePadding: true
      }}
      getContentAnchorEl={null}
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}>
      <MenuItem
        key="choice"
        className={classes.menuItem}
        disabled={isChoiceMessageDisabled}
        onClick={() => handleMenuOptionClick('onChoiceMessage')}>
        <ShowChoiceButton /> Multiple choice ques
      </MenuItem>
      <MenuItem
        key="canned"
        className={classes.menuItem}
        onClick={() => handleMenuOptionClick('onCannedMessage')}>
        <CannedMessageButton /> Canned Msgs
      </MenuItem>
      <Tooltip
        title={disableMessageHistory ? 'Driver is no longer an active driver' : ''}
        disableFocusListener>
        <div>
          <MenuItem
            key="history"
            className={classes.menuItem}
            disabled={disableMessageHistory}
            onClick={() => handleMenuOptionClick('onMessageHistory')}>
            <MsgHistory /> Msg History
          </MenuItem>
        </div>
      </Tooltip>
    </Menu>
  );
};

export default withStyles(styles)(MessageActionMenu);
